<template>
  <el-dialog
    :title="$t('SeaExport.PreviewOfBookingFileParsing')"
    custom-class="intelligent-booking-result-dialog"
    :visible.sync="innerVisible"
    fullscreen
    :modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
  >
    <cargo-left-right-resize
      style="width:100%;height: 100%;"
      :left-style="{'min-width': '550px',width:'50%'}"
      :right-style="{'min-width': '550px',width:'50%'}"
    >
      <template slot="left">
        <div style="width: 100%;height:100%;overflow: auto;">
          <image-preview-cwmi v-if="visible" :image-info="resultArray[pageNum-1].pointer" :cur-focus="curFocus" />
        </div>
      </template>
      <template slot="right">
        <!--        海出托书-->
        <div v-if="details.identificationType === SENDING_0.code" style="width: 100%;height:100%;overflow: auto;">
          <result-form-se-cwmi
            v-if="visible"
            ref="resultForm"
            :details="details"
            :result-array="resultArray"
            :index="pageNum-1"
            @fieldFocus="(val)=>{
              curFocus = val
              resultArray[pageNum-1].curFocus=val
            }"
          />
        </div>
        <div v-if="details.identificationType === SENDING_3.code" style="width: 100%;height:100%;overflow: auto;">
          <result-form-se-customs
            v-if="visible"
            ref="resultForm"
            :details="details"
            :result-array="resultArray"
            :index="pageNum-1"
            @fieldFocus="(val)=>{
              curFocus = val
              resultArray[pageNum-1].curFocus=val
            }"
          />
        </div>
      </template>
    </cargo-left-right-resize>
    <div v-if="details.status === 3" slot="footer" style="display: flex;justify-content: center">
      <el-button no="1" @click="handleClose">{{ $t('Message.Close') }}</el-button>
      <!--分页-->
      <el-pagination
        background
        style="position: absolute;right: 200px"
        :current-page.sync="pageNum"
        :pager-count="5"
        :page-size="1"
        layout="prev, pager, next, jumper"
        :total="total"
      />
    </div>
    <div v-else slot="footer" style="display: flex;justify-content: center">
      <el-button v-if="details.identificationType !== SENDING_3.code" no="2" type="success" @click="handleSave">{{ $t('Payment.save') }}</el-button>
      <el-button v-if="details.identificationType === SENDING_0.code" no="3" type="primary" :title="$t('CargoMsg.Cargo_MultiOrderTip')" @click="handleCreateOrder">{{ $t('SeaExport.GenerateOrder') }}</el-button>
      <el-button no="4" @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
      <!--分页-->
      <el-pagination
        background
        style="position: absolute;right: 200px"
        :current-page.sync="pageNum"
        :pager-count="5"
        :page-size="1"
        layout="prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </el-dialog>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreviewCwmi from '@/views/cargo/v0/ToolAssistant/ocr/components/ImagePreviewCwmi'
import ResultFormSeCwmi from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeCwmi'
import { saveResultJsonCwmi } from '@/api/seaExport/intelligentBooking'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { SALES_CHANNEL_OCR_RECOGNITION, SENDING_0, SENDING_3 } from '@/class/cargo/model/parameters/SystemConstants'
import { deepClone } from '@/utils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import ResultFormSeCustoms from '@/views/cargo/v0/ToolAssistant/ocr/components/ResultFormSeCustoms'

export default {
  name: 'IntelligentBookingResultCwmi',
  components: { ResultFormSeCustoms, ResultFormSeCwmi, ImagePreviewCwmi, CargoLeftRightResize },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      curFocus: '',
      SENDING_0,
      SENDING_3,
      pageNum: 1 // 当前页
    }
  },
  computed: {
    resultArray() {
      return this.details.resultJson ? JSON.parse(this.details.resultJson) : null
    },
    total() { // 总页数
      return JSON.parse(this.details.resultJson).length
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    }
  },
  // watch: {
  //   pageNum: {
  //     async handler(newVal) {
  //       this.curFocus = this.resultArray[this.pageNum - 1].curFocus
  //     }
  //   }
  // },
  methods: {
    async handleCreateOrder() {
      // 先保存json信息
      this.handleSave(false)
      // 多单模式
      const newJobList = []
      for (const result of this.resultArray) {
      // this.resultArray.forEach(async result => {
        const resultJson = result.text.data
        const jobData = resultJson.jobJson
        // const resultJson = this.$refs.resultForm.resultJson
        // const jobData = this.$refs.resultForm.job
        // if (!resultJson || !jobData) {
        //   return
        // }
        const job = await this.converJsonToJob(jobData, resultJson)
        newJobList.push(job)
        this.$logger.log('job=========', job)
      }

      if (newJobList.length === 1) {
        const item = newJobList[0]
        item.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
        if (this.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) { // 远程订舱-海运
          item.lob = 'SE'
          this.$router.push({
            name: 'RemoteBooking',
            params: {
              view: 'detail',
              action: 'add',
              item,
              source: this.source
            }
          })
        } else {
          this.$router.push({
            name: 'SeaBooking',
            params: { job: item }
          })
        }
      } else {
        let i = 1
        let interval = 0
        for (const item of newJobList) {
          item.salesChannel = SALES_CHANNEL_OCR_RECOGNITION.code
          setTimeout(() => {
            if (this.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) { // 远程订舱-海运
              item.lob = 'SE'
              this.$router.push({
                name: 'RemoteBooking',
                query: { openNew: true, key: 'new Job' + i, action: 'add' },
                params: {
                  view: 'detail',
                  action: 'add',
                  item,
                  source: this.source
                }
              })
            } else {
              this.$router.push({
                name: 'SeaBooking',
                query: { openNew: true, key: 'new Job' + i, action: 'add' },
                params: { job: item }
              })
              console.log('new Job + i:', 'new Job' + i)
              console.log('query:', { openNew: true, key: 'new Job' + i, action: 'add' })
            }
            i++
          }, 500 * interval)
          interval++
        }
      }
      this.$emit('close')
    },
    async converJsonToJob(job, resultJson) {
      // const job = this.$refs.resultForm.job
      // const resultJson = this.$refs.resultForm.resultJson
      this.$logger.log('resultJson=========', resultJson)
      const newJob = job ? deepClone(job) : {}
      console.log('job:', job)
      // 发货人
      this.scnChange(job, newJob, 'shipperLine', 'shipperLine', false)
      // 收货人
      this.scnChange(job, newJob, 'consigneeLine', 'consigneeLine', false)
      // 通知人
      this.scnChange(job, newJob, 'notifyPartyLine', 'notifyLine', false)
      // 起运港
      // 卸货港
      // 中转港
      if (job.transferPortCode) {
        newJob.transferPortCode = job.transferPortCode
        newJob.transfering = true
      } else {
        newJob.transfering = false
      }
      // 交货地
      if (!job.destinationPortCode && job.dischargingPortCode) {
        newJob.destinationPortCode = job.dischargingPortCode
      }
      // 交货地区域
      if (newJob.destinationPortCode) {
        const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', newJob.destinationPortCode)
        newJob.placeOfDeliveryRegion = port ? port.region : ''
      }

      newJob.etd = DateUtils.toDateStr(job.etd)
      newJob.sailingDay = DateUtils.getDateWeek(newJob.etd)
      // 船公司
      // 船名
      newJob.vessel = resultJson.vessel
      if (newJob.vessel && newJob.vessel.length > 64) {
        newJob.vessel = newJob.vessel.substr(0, 64)
      }
      await JobUtils.queryCarrierCodeHandler(newJob)
      await cache.load(cacheName.CONFIG)
      const showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
      let voyageValue = 'V.'
      if (!showJudgmentOfVoyageNo) {
        voyageValue = ''
      }
      newJob.voyageFlight = !StrUtils.isEmpty(resultJson.voyageFlight) && !resultJson.voyageFlight.startsWith('V.')
        ? voyageValue + resultJson.voyageFlight : resultJson.voyageFlight
      if (newJob.voyageFlight && newJob.voyageFlight.length > 255) {
        newJob.voyageFlight = newJob.voyageFlight.substr(0, 255)
      }
      // 品名
      newJob.cargoEnglishName = resultJson.goodName ? resultJson.goodName.toUpperCase() : ''
      // 唛头
      newJob.mark = resultJson.marks ? resultJson.marks.toUpperCase() : ''
      // 备注
      newJob.remarks = resultJson.remark
      // 联系人
      newJob.customerContact = resultJson.customerContact
      // 货物尺寸
      newJob.measurements = resultJson.measurements
      newJob.fileSourceType = this.details['fileType']
      newJob.fileSourceName = this.details['fileName']
      newJob.filePreViewContent = this.details['filePreViewContent']
      newJob.fileSourceContent = this.details['fileSourceContent']
      // 运费条款
      // 运输条款job
      // 贸易条款
      // 包装
      // 整箱/拼箱  FCL/LCL
      // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
      if (!StrUtils.isEmpty(job.orderType)) {
        newJob.cargoDoc = [{
          docType: 'HBL',
          releaseType: job.orderType
        }]
        newJob.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: job.orderType
        }]
      }
      newJob.danUNNo = this.details.uuid
      newJob.signMBL = false
      newJob.signHBL = false
      newJob.virtualHBL = false
      newJob.vgm = false
      newJob.ams = false
      newJob.hds = false
      newJob.comercialInspectation = false
      newJob.heating = false
      newJob.itmService = false
      newJob.mblOnly = false
      newJob.batch = false
      newJob.salePrice = false

      // 件数
      const quantityContract = this.changeValue(resultJson, 'quantity', ['CASE', 'PKGS', 'CTNS'])
      if (quantityContract !== 0) {
        newJob.quantityContract = Number(!StrUtils.isEmpty(job.packing) ? quantityContract.replace(job.packing, '') : quantityContract)
        newJob.quantityActual = newJob.quantityContract
      }
      // 毛重
      const weightContract = this.changeValue(resultJson, 'grossWeight', ['KGS', this.$t('SeaExport.KG'), ','])
      newJob.weightContract = Number(weightContract)
      newJob.weightActual = newJob.weightContract
      // 体积
      const cubageContract = this.changeValue(resultJson, 'cubage', ['CBM', this.$t('SeaExport.CBM')])
      newJob.cubageContract = Number(cubageContract)
      newJob.cubageActual = newJob.cubageContract
      // 客户
      // 进仓编号
      if (resultJson.warehouseNo) {
        newJob.warehouseNo = resultJson.warehouseNo
        newJob.jobWarehouseNos = [{ 'warehouseNo': resultJson.warehouseNo }]
      }
      // 客户参考号
      newJob.customerRefNo = resultJson.customerRefNo || ''
      //
      if (job.arriveDate) {
        const warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
        warehouseInfo.arriveDate = job.arriveDate
        newJob.warehouseInfo = [warehouseInfo]
      }
      // 带出联动信息
      await this.setOtherInfo(newJob, resultJson)
      return JSON.parse(JSON.stringify(newJob, (key, value) => {
        if (typeof value !== 'boolean') {
          if (!value || (Array.isArray(value) && !value.length || (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length))) {
            return undefined
          }
        }
        return value
      }))
    },
    // 联动带出逻辑
    async setOtherInfo(newJob, resultJson) {
      // 揽货类型
      // 根据客户属性的揽货类型。单勾选自揽货=带出“自揽货“，  单勾选指定货=带出“指定货“。  同时勾选= 带出的是“自揽货”
      let customerDetail = ''
      if (!newJob.cargoSource && newJob.customerId && Number(newJob.customerId) > 0) {
        const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', newJob.customerId)
        customerDetail = customer ? await Company.loadCustomer(customer.uuid).then(list => list.length > 0 ? list[0] : null) : ''
        let newCargoSource = ''
        if (customer && customerDetail) {
          if (customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          } else if (customerDetail.designated && !customerDetail.seftCanvass) {
            newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          } else if (!customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          }
        }
        newJob.cargoSource = newCargoSource
      }
      if (newJob.cargoSource) {
        // 根据“委托单位+卸货港+指定货”带出指定货代理
        if (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          // 指定货代理
          if (customerDetail && newJob.dischargingPortCode) {
            const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const agent of portDestinationAgents) {
                if (newJob.dischargingPortCode === agent.destinationPort) {
                  newJob.designationAgent = agent.destinationAgentId
                  break
                }
              }
            }
          }
        }

        // 分单运费条款
        if (!newJob.paymentTermHBL) {
          newJob.paymentTermHBL = (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'CC' : 'PP'
        }

        // 贸易条款
        if (!newJob.incoTerm) {
          newJob.incoTerm = (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'FOB' : 'CIF'
        }
      }
      // 计费重量
      if (newJob.chargeWeight === 0 && resultJson.cubage && resultJson.grossWeight) {
        newJob.chargeWeight = this.handleChargeWeight(resultJson.cubage, resultJson.grossWeight)
      }
    },
    // 计算计费重量
    handleChargeWeight(cubage, weight) {
      if (!weight) {
        weight = 0
      }
      if (!cubage) {
        cubage = 0
      }
      if (isNaN(weight) || isNaN(cubage)) {
        return 0
      }
      weight = weight ? Number(weight) : 0
      cubage = cubage ? Number(cubage) : 0
      //
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      return parseFloat(weight.toFixed(3))
    },
    handleSave(closeDialog = true) {
      const loading = getLoading4Cxt(this)
      this.resultArray.forEach(async result => {
        const resultJson = result.text.data
        const jobData = resultJson.jobJson
        // 发货人
        this.scnChange(jobData, resultJson, 'shipperLine', 'shipperLine', true)
        // 收货人
        this.scnChange(jobData, resultJson, 'consigneeLine', 'consigneeLine', true)
        // 通知人
        this.scnChange(jobData, resultJson, 'notifyLine', 'notifyLine', true)
        // 整理箱子
        if (jobData.seaEQ) {
          let containerInfos = ''

          for (const data of jobData.seaEQ) {
            if (containerInfos.length > 0) {
              containerInfos += ','
            }
            containerInfos += data.eqSizeOrg + '\'' + data.eqTypeOrg + ':' + data.eqQuantity
          }
          resultJson.containerInfos = containerInfos
        }
        // 清除焦点
        resultJson.curFocus = ''
      })
      const params = {
        uuid: this.details.uuid,
        resultArray: this.resultArray
      }

      saveResultJsonCwmi(params).then(res => {
        if (closeDialog) {
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.$emit('success')
        }
      }).finally(() => {
        loading.close()
      })
    },
    handleClose() {
      console.log('result close')
      this.$emit('close')
    },
    // async convertJsonToJob(job) {
    //   const newJob = {}
    //   // 发货人
    //   this.scnChange(job, newJob, 'shipperLine', 'shipperLine', false)
    //   // 收货人
    //   this.scnChange(job, newJob, 'consigneeLine', 'consigneeLine', false)
    //   // 通知人
    //   this.scnChange(job, newJob, 'notifyPartyLine', 'notifyLine', false)
    //   // 起运港
    //   const loadingPortCode = this.changeCodeValue(job, 'loadingPortCode', TYPE_NAMES.basic_data_Seaport, 'englishName')
    //   newJob.loadingPortCode = loadingPortCode === null ? '' : loadingPortCode
    //   // 卸货港
    //   const dischargingPortCode = this.changeCodeValue(job, 'dischargingPortCode', TYPE_NAMES.basic_data_Seaport, 'englishName')
    //   newJob.dischargingPortCode = dischargingPortCode === null ? '' : dischargingPortCode
    //   // // 中转港
    //   // const transferPortCode = this.changeCodeValue(job, 'transferPortCode', TYPE_NAMES.basic_data_Seaport, 'englishName')
    //   // newJob.transferPortCode = transferPortCode === null ? '' : transferPortCode
    //   // 交货地
    //   const destinationPortCode = this.changeCodeValue(job, 'destinationPortCode', TYPE_NAMES.basic_data_Seaport, 'englishName')
    //   newJob.destinationPortCode = destinationPortCode === null ? '' : destinationPortCode
    //   if (newJob.destinationPortCode === '' && newJob.dischargingPortCode !== '') {
    //     newJob.destinationPortCode = newJob.dischargingPortCode
    //   }
    //   newJob.etd = this.toDateStr(job.etd.value)
    //   newJob.sailingDay = DateUtils.getDateWeek(newJob.etd)
    //   // 船公司
    //   const carrierId = this.changeCodeValue(job, 'carrier', TYPE_NAMES.basic_data_Company, 'shortName', 'cmpIdx', true)
    //   newJob.carrierId = carrierId === null ? 0 : carrierId
    //   // 船名
    //   newJob.vessel = job.vessel.value
    //   if (newJob.vessel && newJob.vessel.length > 64) {
    //     newJob.vessel = newJob.vessel.substr(0, 64)
    //   }
    //   newJob.voyageFlight = StrUtils.isEmpty(job.voyageFlight) ? 'V.' + job.voyage.value : job.voyage.value
    //   if (newJob.voyageFlight && newJob.voyageFlight.length > 255) {
    //     newJob.voyageFlight = newJob.voyageFlight.substr(0, 255)
    //   }
    //   // 件数
    //   const quantityContract = this.changeValue(job, 'quantity', ['CASE', 'PKGS', 'CTNS'])
    //   if (quantityContract !== 0) {
    //     newJob.quantityContract = Number(!StrUtils.isEmpty(job.packing.value) ? quantityContract.replace(job.packing.value, '') : quantityContract)
    //     newJob.quantityActual = newJob.quantityContract
    //   }
    //   // 毛重
    //   const weightContract = this.changeValue(job, 'grossWeight', ['KGS', this.$t('SeaExport.KG'), ','])
    //   newJob.weightContract = Number(weightContract)
    //   newJob.weightActual = newJob.weightContract
    //   // 体积
    //   const cubageContract = this.changeValue(job, 'cubage', ['CBM', this.$t('SeaExport.CBM')])
    //   newJob.cubageContract = Number(cubageContract)
    //   newJob.cubageActual = newJob.cubageContract
    //   // 计费重量RT, 默认根据实际计算
    //   // newJob.chargeWeight = Number(cubageContract)
    //   let calWeight = newJob.weightActual
    //   let calCubage = newJob.cubageActual
    //   await cache.load(cacheName.CONFIG)
    //   const chargeWeightCalculationMode = Number(cache.config.get('ChargeWeightCalculationMode'))
    //   if (chargeWeightCalculationMode === 1) { // 按委托进行计算
    //     calWeight = newJob.weightContract
    //     calCubage = newJob.cubageContract
    //   }
    //   calWeight = calWeight / 1000
    //   if (calCubage > calWeight) {
    //     calWeight = calCubage
    //   }
    //   if (calWeight > 0 && calWeight < 1) {
    //     calWeight = 1.00
    //   }
    //   newJob.chargeWeight = parseFloat(calWeight.toFixed(3))
    //   // 品名
    //   if (job.destinationPortCode && job.destinationPortCode.value) {
    //     newJob.cargoEnglishName = job.destinationPortCode.value.toUpperCase()
    //   }
    //   // 唛头
    //   if (job.marks && job.marks.value) {
    //     newJob.mark = job.marks.value.toUpperCase()
    //   }
    //   // 备注
    //   newJob.remarks = (job.remark || '').value
    //   // 联系人
    //   newJob.customerContact = (job.customerContact || '').value
    //   // 货物尺寸
    //   if (job.measurements && job.measurements.value) {
    //     newJob.measurements = job.measurements.value
    //   }
    //   newJob.fileSourceType = this.details['fileType']
    //   newJob.fileSourceName = this.details['fileName']
    //   newJob.filePreViewContent = this.details['filePreViewContent']
    //   newJob.fileSourceContent = this.details['fileSourceContent']
    //   // 运费条款
    //   const paymentTermHBL = this.changeCodeValue(job, 'paymentTerm', TYPE_NAMES.basic_data_PaymentTerm)
    //   if (!StrUtils.isEmpty(paymentTermHBL)) {
    //     newJob.paymentTermHBL = paymentTermHBL
    //   }
    //   // 运输条款job
    //   const freightTermHBL = this.changeCodeValue(job, 'freightTerm', TYPE_NAMES.basic_data_ShippingTerm)
    //   if (!StrUtils.isEmpty(freightTermHBL)) {
    //     newJob.freightTermHBL = freightTermHBL
    //     newJob.freightTerm = freightTermHBL
    //   }
    //   // 贸易条款
    //   // const incoTerm = this.changeCodeValue(job, 'incoTerm', TYPE_NAMES.basic_data_IncoTerm)
    //   // if (!StrUtils.isEmpty(incoTerm)) {
    //   //   newJob.incoTerm = incoTerm
    //   // }
    //   // 包装
    //   const packing = this.changeCodeValue(job, 'packing', TYPE_NAMES.basic_data_Packing, 'name')
    //   if (!StrUtils.isEmpty(packing)) {
    //     newJob.packing = packing
    //   }
    //   if (job.eqs && job.eqs.value) {
    //     const seaEqs = job.eqs.value
    //     if (seaEqs && !StrUtils.isEmpty(seaEqs)) {
    //       if (seaEqs.length > 0) {
    //         for (const seaEq of seaEqs) {
    //           seaEq.eqQuantity = seaEq.eQuantity
    //           seaEq.eqSize = seaEq.eQsize
    //           seaEq.eqType = seaEq.eQtype
    //         }
    //       }
    //       newJob.seaEQ = seaEqs
    //     }
    //   }
    //   // 整箱/拼箱  FCL/LCL
    //   newJob.containerLoadType = ''
    //   if (job.containerLoadType && !StrUtils.isEmpty(job.containerLoadType.value)) {
    //     // irs 返回关键字
    //     if (job.containerLoadType.hasOwnProperty('code')) {
    //       newJob.containerLoadType = job.containerLoadType.code
    //     }
    //     if (StrUtils.isEmpty(newJob.containerLoadType)) {
    //       newJob.containerLoadType = job.containerLoadType.value
    //     }
    //   }
    //   // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    //   // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
    //   if (!StrUtils.isEmpty(job.orderType.value)) {
    //     // irs 返回关键字
    //     let releaseType = 1
    //     if (job.orderType.hasOwnProperty('code')) {
    //       const orderType = job.orderType.code
    //       if (!StrUtils.isEmpty(orderType)) {
    //         if (orderType === 'ORIGINAL') {
    //           releaseType = 1
    //         } else if (orderType === 'SURRENDERED') {
    //           releaseType = 2
    //         } else if (orderType === 'SEA WAYBILL') {
    //           releaseType = 3
    //         }
    //       }
    //     } else {
    //       releaseType = ColumnUtils.getBlModeSerialNumberByName(job.orderType.value)
    //     }
    //     newJob.seaCargoDoc = [{
    //       docType: 'HBL',
    //       releaseType: releaseType
    //     }]
    //   }
    //   newJob.danUNNo = this.details.uuid
    //   newJob.signMBL = false
    //   newJob.signHBL = false
    //   newJob.virtualHBL = false
    //   newJob.vgm = false
    //   newJob.ams = false
    //   newJob.hds = false
    //   newJob.comercialInspectation = false
    //   newJob.heating = false
    //   newJob.itmService = false
    //   newJob.mblOnly = false
    //   newJob.batch = false
    //   newJob.salePrice = false
    //   return JSON.parse(JSON.stringify(newJob, (key, value) => {
    //     if (typeof value !== 'boolean') {
    //       if (!value || (Array.isArray(value) && !value.length || (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length))) {
    //         return undefined
    //       }
    //     }
    //     return value
    //   }))
    // },
    scnChange(job, newJob, sourceField, targetField, de) {
      for (let i = 7; i >= 0; --i) {
        if (job[sourceField + i]) {
          newJob[targetField + i] = job[sourceField + i].toUpperCase()
        } else {
          // 设置默认值
          if (de) {
            newJob[targetField + i] = ''
          }
        }
      }
    },
    toDateStr(dateStr) {
      if (!dateStr) {
        return ''
      }
      // 验证日期距离1970年是多长时间，转换之后是否是数字、验证传入的日期是否是数字，若是数字则长度不能少于8位
      if (isNaN(Date.parse(dateStr)) || dateStr.length < 8) {
        return ''
      }
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 验证日期转换之后年月日是否正确
      if (isNaN(year) || isNaN(month) || isNaN(day) || month <= 0 || month > 12 || day < 0 || day > 31) {
        return ''
      }
      return DateUtils.formatStandardDate(date)
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        result = job[targetField]
        result = result.trim()
        for (const element of replaceArr) {
          result = result.replace(element, '')
        }
      }
      return result
    },
    changeCodeValue(job, fieldKey, typeName, sourceField, targetField, useCode) {
      let result = null
      if (!StrUtils.isEmpty(job[fieldKey].value)) {
        // irs 返回关键字
        if (job[fieldKey].hasOwnProperty('code')) {
          result = job[fieldKey].code
        }
        //
        if (!StrUtils.isEmpty(result) && useCode) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), result, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
        if (StrUtils.isEmpty(result)) {
          const valueCode = ColumnUtils.resolveColumnLabel(typeName, (!StrUtils.isEmpty(sourceField) ? sourceField : 'code'), job[fieldKey].value, (!StrUtils.isEmpty(targetField) ? targetField : 'code'))
          if (valueCode !== null) {
            result = valueCode
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
  }
}
</style>
